<template>
  <page :manualInit="claimListing.init" :manualErr="claimListing.initErr">
    <v-container fluid grid-list-md>
      <v-layout row wrap align-end>
        <v-flex xs7 md9 lg10>
          <card-menu :items="cardMenu" @cardReturn="visibleControl" subMenu></card-menu>
        </v-flex>
        <v-flex xs5 md3 lg2>
          <v-container fluid class="pa-0" align="right">
            <span align="right">
              <div class="text-center">
                <v-tooltip top v-if="checkAccess([permissionKeys.perm_031015])">
                  <template v-slot:activator="{ on }">
                    <v-btn class="mx-2" fab dark color="primary" v-on="on" @click.native="doButtons('reopen')"
                      ><v-icon dark>mdi-refresh</v-icon></v-btn
                    >
                  </template>
                  <span>Reopen Claim</span>
                </v-tooltip>
                <v-tooltip top v-if="checkAccess([permissionKeys.perm_031020])">
                  <template v-slot:activator="{ on }">
                    <v-btn class="mx-2" fab dark color="error" v-on="on" @click.native="doButtons('delete')"><v-icon dark>mdi-delete</v-icon></v-btn>
                  </template>
                  <span>Delete Claim</span>
                </v-tooltip>
              </div>
            </span>
          </v-container>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12>
          <form>
            <v-expansion-panels>
              <v-expansion-panel>

              </v-expansion-panel>
            </v-expansion-panels>
          </form>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12>
          <form>
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn class="mx-2" fab dark small color="teal" v-on="on" @click.native.stop="showFilterList = true">
                          <v-icon dark>mdi-format-list-bulleted</v-icon>
                        </v-btn>
                      </template>
                      <span>Show Saved Filters</span>
                    </v-tooltip>
                    Filters for {{ listMode }}
                    <span class="caption grey--text font-weight-light">
                      {{ defaultFilter.filterName !== undefined ? ' (' + defaultFilter.filterName + ')' : '' }}</span
                    >
                  </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <!-- filter text-field -->
                        <v-flex lg4 xs6>
                          <v-autocomplete
                            :items="polTypeAppIdList"
                            v-model="filters.polTypeAppId"
                            :label="filtersLabel.polTypeAppId"
                            item-text="label"
                            item-value="value"
                            data-vv-name="polTypeAppId"
                            :data-vv-as="filtersLabel.polTypeAppId"
                            :error-messages="errors.collect('polTypeAppId')"
                            clearable
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex lg8 xs6></v-flex>
                        <v-flex lg4 xs6>
                          <v-text-field
                            v-model="filters.clmNo"
                            :label="filtersLabel.clmNo"
                            :error-messages="errors.collect('clmNo')"
                            data-vv-name="clmNo"
                            :data-vv-as="filtersLabel.clmNo"
                            v-validate="'entry|max:12'"
                            :maxlength="12"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg4 xs6>
                          <v-text-field
                            v-model="filters.polNo"
                            :label="filtersLabel.polNo"
                            :error-messages="errors.collect('polNo')"
                            data-vv-name="polNo"
                            :data-vv-as="filtersLabel.polNo"
                            v-validate="'entry|max:16'"
                            :maxlength="16"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg4 xs6>
                          <v-text-field
                            v-model="filters.insdName1"
                            :label="filtersLabel.insdName1"
                            type="tel"
                            :error-messages="errors.collect('insdName1')"
                            data-vv-name="insdName1"
                            :data-vv-as="filtersLabel.insdName1"
                            v-validate="'max:60'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg4 xs6>
                          <v-autocomplete
                            v-model="filters.busCls"
                            :label="filtersLabel.busCls"
                            :items="busClsList"
                            item-text="label"
                            item-value="value"
                            :error-messages="errors.collect('busCls')"
                            data-vv-name="busCls"
                            :data-vv-as="filtersLabel.busCls"
                            v-validate="'entry'"
                            clearable
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex lg4 xs6>
                          <v-text-field
                            v-model="filters.clmEvent"
                            :label="filtersLabel.clmEvent"
                            type="tel"
                            :error-messages="errors.collect('clmEvent')"
                            data-vv-name="clmEvent"
                            :data-vv-as="filtersLabel.clmEvent"
                            v-validate="'entry'"
                            clearable
                          >
                            <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                              <v-icon color="info" @click="showClmEventHelpList = true">mdi-magnify</v-icon>
                            </v-slide-x-reverse-transition>
                          </v-text-field>
                        </v-flex>
                        <v-flex lg4 xs6>
                          <cal-picker
                            v-model="filters.lossDate"
                            :label="filtersLabel.lossDate"
                            :data-vv-as="filtersLabel.lossDate"
                            data-vv-name="lossDate"
                          ></cal-picker>
                        </v-flex>
                        <v-flex lg4 xs6>
                          <v-autocomplete
                            :items="directRIList"
                            v-model="filters.dri"
                            :label="filtersLabel.dri"
                            item-text="label"
                            item-value="value"
                            data-vv-name="dri"
                            :data-vv-as="filtersLabel.dri"
                            :error-messages="errors.collect('dri')"
                            clearable
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex lg4 xs6>
                          <v-autocomplete
                            :items="polTypeList"
                            v-model="filters.polType"
                            :label="filtersLabel.polType"
                            item-text="label"
                            item-value="value"
                            data-vv-name="polType"
                            :data-vv-as="filtersLabel.polType"
                            :error-messages="errors.collect('polType')"
                            clearable
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex lg4 xs6>
                          <v-text-field
                            v-model="filters.refNo"
                            :label="filtersLabel.refNo"
                            :error-messages="errors.collect('refNo')"
                            data-vv-name="refNo"
                            :data-vv-as="filtersLabel.refNo"
                            v-validate="'entry|max:16'"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <transition name="slide-x-transition" mode="out-in">
                        <v-layout row wrap v-if="showDetailFilters">
                          <v-flex lg4 xs6>
                            <v-select
                              v-model="filters.clmStat"
                              :items="clmStatList"
                              :label="filtersLabel.clmStat"
                              item-text="label"
                              item-value="value"
                              clearable
                            />
                          </v-flex>
                          <v-flex lg4 xs6>
                            <v-text-field
                              v-model="filters.cedantClmNo"
                              :label="filtersLabel.cedantClmNo"
                              :error-messages="errors.collect('cedantClmNo')"
                              data-vv-name="cedantClmNo"
                              :data-vv-as="filtersLabel.cedantClmNo"
                              v-validate="'entry|max:60'"
                            ></v-text-field>
                          </v-flex>
                          <v-flex lg4 xs6>
                            <v-text-field
                              v-model="filters.contrtNo"
                              :label="filtersLabel.contrtNo"
                              :error-messages="errors.collect('contrtNo')"
                              data-vv-name="contrtNo"
                              :data-vv-as="filtersLabel.contrtNo"
                              v-validate="'entry|max:60'"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 class="ma-0 pa-0" />
                          <v-flex lg4 xs6 v-if="filterTab == 'Claim Details' || filterTab == 'Driver Details'">
                            <v-text-field
                              v-uppercase="filters.vehRegNo"
                              v-model="filters.vehRegNo"
                              :label="filtersLabel.vehRegNo"
                              :error-messages="errors.collect('vehRegNo')"
                              data-vv-name="vehRegNo"
                              :data-vv-as="filtersLabel.vehRegNo"
                            ></v-text-field>
                          </v-flex>
                          <v-flex lg4 xs6 v-if="filterTab == 'Claim Details' || filterTab == 'Driver Details'">
                            <v-text-field
                              v-model="filters.vehVsl"
                              :label="filtersLabel.vehVsl"
                              :error-messages="errors.collect('vehVsl')"
                              data-vv-name="vehVsl"
                              :data-vv-as="filtersLabel.vehVsl"
                              v-validate="'entry|max:50'"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 class="ma-0 pa-0" />
                          <v-flex lg4 xs6 v-if="filterTab == 'Claim Details'">
                            <v-text-field
                              v-model="filters.engineNo"
                              :label="filtersLabel.engineNo"
                              :error-messages="errors.collect('engineNo')"
                              data-vv-name="engineNo"
                              :data-vv-as="filtersLabel.engineNo"
                              v-validate="'entry|max:60'"
                            ></v-text-field>
                          </v-flex>
                          <v-flex lg4 xs6 v-if="filterTab == 'Claim Details'">
                            <v-text-field
                              v-model="filters.chassisNo"
                              :label="filtersLabel.chassisNo"
                              :error-messages="errors.collect('chassisNo')"
                              data-vv-name="chassisNo"
                              :data-vv-as="filtersLabel.chassisNo"
                              v-validate="'entry|max:60'"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 class="ma-0 pa-0" />
                          <v-flex lg4 xs6 v-if="filterTab == 'Driver Details'">
                            <v-text-field
                              v-model="filters.driverName"
                              :label="filtersLabel.driverName"
                              :error-messages="errors.collect('driverName')"
                              data-vv-name="driverName"
                              :data-vv-as="filtersLabel.driverName"
                              v-validate="'entry|max:60'"
                            ></v-text-field>
                          </v-flex>
                          <v-flex lg4 xs6 v-if="filterTab == 'Driver Details'">
                            <v-text-field
                              v-model="filters.driverNric"
                              :label="filtersLabel.driverNric"
                              :error-messages="errors.collect('driverNric')"
                              data-vv-name="driverNric"
                              :data-vv-as="filtersLabel.driverNric"
                              v-validate="'entry|max:60'"
                            ></v-text-field>
                          </v-flex>
                          <v-flex lg4 xs6 v-if="filterTab == 'Claimant Details' || filterTab == 'Item Details'">
                            <v-text-field
                              v-uppercase="filters.vehRegNo"
                              v-model="filters.vehRegNo"
                              :label="filtersLabel.clmtVehRegNo"
                              :error-messages="errors.collect('vehRegNo')"
                              data-vv-name="vehRegNo"
                              :data-vv-as="filtersLabel.vehRegNo"
                            ></v-text-field>
                          </v-flex>
                          <v-flex lg4 xs6 v-if="filterTab == 'Claimant Details' || filterTab == 'Item Details'">
                            <v-text-field
                              v-model="filters.clmtName"
                              :label="filtersLabel.clmtName"
                              :error-messages="errors.collect('clmtName')"
                              data-vv-name="clmtName"
                              :data-vv-as="filtersLabel.clmtName"
                              v-validate="'entry|max:60'"
                            ></v-text-field>
                          </v-flex>
                          <v-flex lg4 xs6 v-if="filterTab == 'Item Details'">
                            <v-autocomplete
                              v-model="filters.nol1"
                              :label="filtersLabel.nol1"
                              :items="nol1List"
                              item-text="label"
                              item-value="value"
                              :error-messages="errors.collect('nol1')"
                              data-vv-name="nol1"
                              :data-vv-as="filtersLabel.nol1"
                              clearable
                            ></v-autocomplete>
                          </v-flex>
                        </v-layout>
                      </transition>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn text @click.native="showDetailFilters = true" v-if="!showDetailFilters">Show More Filters</v-btn>
                    <v-btn text @click.native="showDetailFilters = false" v-if="showDetailFilters">Show Less Filters</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text @click.native="saveFilter = true">Save Current Filters</v-btn>
                    <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </form>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-tabs v-model="tabs">
              <v-tab v-for="(detailTab, x) in detailTabs" :key="x" :disabled="disabledTabs(detailTab)" @click="doColumn(detailTab, columns)">{{
                detailTab
              }}</v-tab>
              <v-spacer></v-spacer>
              <v-btn class="mr-2 mt-2" color="primary" @click.native="doCreate()" v-if="checkAccess([permissionKeys.perm_031035]) && this.deleteMode === false">
                <span>New Claim</span>
                <v-icon right dark>mdi-plus</v-icon>
              </v-btn>
              <v-menu offset-x :nudge-left="370" :close-on-content-click="false" :min-width="300" :max-height="400">
                <template v-slot:activator="{ on }">
                  <v-btn color="secondary" class="white--text mr-2 mt-2" v-on="on">
                    <span>Columns</span>
                    <v-icon right dark>mdi-table-column-plus-after</v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-card-text>
                    <template v-if="columns.length > 0">
                      <v-checkbox
                        v-for="column in columns"
                        :key="column.value"
                        :label="column.text"
                        :value="column.value"
                        v-model="selectedColumns"
                      ></v-checkbox>
                    </template>
                    <template v-else>No column found</template>
                  </v-card-text>
                </v-card>
              </v-menu>
              <v-btn class="mr-2 mt-2" v-if="checkAccess([permissionKeys.perm_031095])" color="info" @click.native="doExportFilters">
                <span>{{ labels.exportList }}</span>
                <v-icon right dark>mdi-file-excel</v-icon>
              </v-btn>
            </v-tabs>
            <v-tabs-items v-model="tabs" touchless>
              <v-tab-item :key="1">
                <v-flex xs12>
                  <v-card>
                    <v-data-table
                      v-bind:headers="listHeaders"
                      v-bind:items="items"
                      :server-items-length="totalItems"
                      :footer-props="{'items-per-page-options': itemsPerPage }"
                      v-bind:options.sync="pagination"
                      item-key="key"
                      :loading="loading"
                      :no-data-text="noDataText"
                    >
                      <template v-slot:item="row"
                        ><tr>
                          <td v-for="column in selectedColumns" :key="column">{{ row.item[column] }}</td>
                          <td class="table-action-header">
                            <table-action
                              :rowData="row"
                              :query="canQuery(row) && checkAccess([permissionKeys.perm_031050])"
                              @query="doQuery(row, false) && checkAccess([permissionKeys.perm_031050])"
                              :remove="canDelete(row)"
                              @remove="doQuery(row, true) && checkAccess([permissionKeys.perm_031020])"
                              :review="canReview(row) && checkAccess([permissionKeys.perm_031045])"
                              @review="doReview"
                              :reopen="canReviewReopen(row)"
                              @reopen="doReview"
                              :create="canCreate(row)"
                              @create="doPay"
                              :loading="loading"
                            ></table-action>
                          </td></tr
                      ></template>
                    </v-data-table>
                  </v-card>
                </v-flex>
              </v-tab-item>
              <v-tab-item :key="2">
                <v-flex xs12>
                  <v-card>
                    <v-data-table
                      v-bind:headers="listHeaders"
                      v-bind:items="items"
                      :server-items-length="totalItems"
                      :footer-props="{'items-per-page-options': itemsPerPage }"
                      v-bind:options.sync="pagination"
                      item-key="key"
                      :loading="loading"
                      :no-data-text="noDataText"
                    >
                      <template v-slot:item="row"
                        ><tr>
                          <td v-for="column in selectedColumns" :key="column">{{ row.item[column] }}</td>
                          <td class="table-action-header">
                            <table-action
                              :rowData="row"
                              :query="canQuery(row) && checkAccess([permissionKeys.perm_031050])"
                              @query="doQuery(row, false) && checkAccess([permissionKeys.perm_031050])"
                              :review="canReview(row) && checkAccess([permissionKeys.perm_031045])"
                              @review="doReview"
                              :reopen="canReviewReopen(row)"
                              @reopen="doReview"
                              :remove="canDelete(row)"
                              @remove="doQuery(row, true) && checkAccess([permissionKeys.perm_031020])"
                              :create="canCreate(row)"
                              @create="doPay"
                              :loading="loading"
                            ></table-action>
                          </td></tr
                      ></template>
                    </v-data-table>
                  </v-card>
                </v-flex>
              </v-tab-item>
              <v-tab-item :key="3">
                <v-flex xs12>
                  <v-card>
                    <v-data-table
                      v-bind:headers="listHeaders"
                      v-bind:items="items"
                      :server-items-length="totalItems"
                      :footer-props="{'items-per-page-options': itemsPerPage }"
                      v-bind:options.sync="pagination"
                      item-key="key"
                      :loading="loading"
                      :no-data-text="noDataText"
                    >
                      <template v-slot:item="row"
                        ><tr>
                          <td v-for="column in selectedColumns" :key="column">{{ row.item[column] }}</td>
                          <td class="table-action-header">
                            <table-action
                              :rowData="row"
                              :query="canQuery(row) && checkAccess([permissionKeys.perm_031050])"
                              @query="doQuery(row, false) && checkAccess([permissionKeys.perm_031050])"
                              :remove="canDelete(row)"
                              @remove="doQuery(row, true) && checkAccess([permissionKeys.perm_031020])"
                              :review="canReview(row) && checkAccess([permissionKeys.perm_031045])"
                              @review="doReview"
                              :reopen="canReviewReopen(row)"
                              @reopen="doReview"
                              :create="canCreate(row)"
                              @create="doPay"
                              :loading="loading"
                            ></table-action>
                          </td></tr
                      ></template>
                    </v-data-table>
                  </v-card>
                </v-flex>
              </v-tab-item>
              <v-tab-item :key="4">
                <v-flex xs12>
                  <v-card>
                    <v-data-table
                      v-bind:headers="listHeaders"
                      v-bind:items="items"
                      :server-items-length="totalItems"
                      :footer-props="{'items-per-page-options': itemsPerPage }"
                      v-bind:options.sync="pagination"
                      item-key="key"
                      :loading="loading"
                      :no-data-text="noDataText"
                    >
                      <template v-slot:item="row"
                        ><tr>
                          <td v-for="column in selectedColumns" :key="column">{{ row.item[column] }}</td>
                          <td class="table-action-header">
                            <table-action
                              :rowData="row"
                              :query="canQuery(row) && checkAccess([permissionKeys.perm_031050])"
                              @query="doQuery(row, false) && checkAccess([permissionKeys.perm_031050])"
                              :remove="canDelete(row)"
                              @remove="doQuery(row, true) && checkAccess([permissionKeys.perm_031020])"
                              :review="canReview(row) && checkAccess([permissionKeys.perm_031045])"
                              @review="doReview"
                              :reopen="canReviewReopen(row)"
                              @reopen="doReview"
                              :create="canCreate(row)"
                              @create="doPay"
                              :loading="loading"
                            ></table-action>
                          </td></tr
                      ></template>
                    </v-data-table>
                  </v-card>
                </v-flex>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-flex>
      </v-layout>
      <confirm v-model="showDeletePrompt" @ok="doRemove"> Are you sure you want to delete claim {{ this.claimForDelete.clmNo }}? </confirm>
      <v-dialog v-model="showErrorDialog" width="800px">
        <v-card>
          <v-toolbar dense color="grey lighten-3" flat>
            <v-icon>mdi-information</v-icon>
            <v-toolbar-title>System Information</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <div v-if="messages.length > 0" class="pb-3">
              <v-subheader>Oops something went wrong:</v-subheader>
              <ul class="showErrorMsgs">
                <li v-for="(error, index) in messages" :key="index">
                  {{ error.message }}
                </li>
              </ul>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Common Search Filter - Start -->
      <v-dialog v-model="showFilterList" width="800px" persistent>
        <SearchFilter
          :boolRefresh="showFilterList"
          :filterTitle="'Saved Filters - Claims Listing'"
          @close="showFilterList = false"
          :filterCode="filterCode"
          @applyDefaultFilter="applyDefaultFilter"
        ></SearchFilter>
      </v-dialog>
      <v-dialog v-model="saveFilter" width="800px" persistent>
        <UpdateSearchFilter
          :boolRefresh="saveFilter"
          :dialogTitle="'Filter'"
          :actionName="'new'"
          :filters="filters"
          @close="saveFilter = false"
          @reloadList="reloadList"
          :filterCode="filterCode"
          @applyDefaultFilter="applyDefaultFilter"
        ></UpdateSearchFilter>
      </v-dialog>
      <v-dialog v-model="showClmEventHelpList" width="800px" persistent>
        <clm-event-help-list @close="showClmEventHelpList = false" @assign-clm-event="assignClmEvent" />
      </v-dialog>
      <!-- Common Search Filter - End -->
      <columns-selector v-if="exportList.cfmExportClmList" :titleTabDet="this.filterTab" :columns="columns" v-model="exportList.cfmExportClmList" @export="doExportList"/>
      <warning v-model="exportList.promptFilterWarning" :label="exportList.promptFilterWarningMsg" @ok="exportList.cfmExportClmList = true"/>
    </v-container>
  </page>
</template>

<script>
import clone from 'clone'
import { listMixin } from '@/mixins/listMixin'
import { expandURI, filterQuery } from '@/utils/ajax'
import { formatDisplayDateTime2, removeTime } from '@/utils/date'
import addDays from 'date-fns/addDays'
import { mainClass } from '@/const/claims'
import { CLAIMS_LOAD_BACK_LISTING, CLAIMS_HASRIORRESADJ_LOADING } from '@/store/types'
import SearchFilter from '@/components/core/common/dialog/SearchFilter'
import UpdateSearchFilter from '@/components/core/common/dialog/UpdateSearchFilter'
import { recordLockMixin } from '@/mixins/common/recordLockMixin'
import ClmEventHelpList from '@/components/core/common/dialog/ClmEventHelpList'
import { permissionKeys } from '@/mixins/global/permissionKey'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      // Common Search Filter - Start
      filterCode: 'CLM',
      newFilter: false,
      saveFilter: false,
      showFilterList: false,
      showClmEventHelpList: false,
      permissionKeys: permissionKeys,
      defaultFilter: {},
      // Common Search Filter - End
      cardMenu: [
        { text: 'Claim', icon: 'mdi-file-check', name: '', params: { tab: 'listing' }, access: '', default: true },
        { text: 'Payment', icon: 'fas fa-hand-holding-usd', name: '', params: { tab: 'payment' }, access: '' }
      ],
      visibleTab: {},
      listMode: 'Claim',
      detailTab: 'Claim Details',
      tab: undefined,
      tabs: undefined,
      buttons: undefined,
      columns: [],
      defaultColumns: [
        { text: 'Claim No.', value: 'clmNo' },
        { text: 'Status', value: 'clmStat' }
      ],
      filterTab: 'Claim Details',
      detailTabs: ['Claim Details', 'Driver Details', 'Claimant Details', 'Item Details'],
      selectedColumns: ['clmNo', 'polNo', 'insdName1', 'busCls'],
      filtersLabel: {
        polTypeAppId: 'Main Classes',
        clmNo: 'Claim No.',
        polNo: 'Policy No.',
        insdName1: 'Insured Name',
        busCls: 'Business Class',
        clmEvent: 'Claim Event No.',
        lossDate: 'Loss Date',
        vehRegNo: 'Vehicle Registration No.',
        clmtVehRegNo: 'Claimant Vehicle',
        engineNo: 'Engine No.',
        chassisNo: 'Chassis No.',
        clmStat: 'Claims Status',
        cedantClmNo: 'Cedant Claim No.',
        contrtNo: 'Contract No.',
        driverName: 'Driver Name',
        driverNric: 'Driver NRIC',
        clmtName: 'Claimant Name',
        inter: 'Service Provider',
        name: 'Service Provider Name',
        nol1: 'Nature of Loss',
        dri: 'DRI',
        polType: 'Policy Type',
        vehVsl: 'Vehicle / Vessel',
        refNo: 'Claim Ref No.'
      },
      filters: {
        polTypeAppId: undefined,
        polType: undefined,
        review: undefined,
        clmNo: undefined,
        polNo: undefined,
        insdName1: undefined,
        busCls: undefined,
        clmEvent: undefined,
        lossDate: undefined,
        vehRegNo: undefined,
        engineNo: undefined,
        chassisNo: undefined,
        clmStat: undefined,
        cedantClmNo: undefined,
        contrtNo: undefined,
        driverName: undefined,
        driverNric: undefined,
        clmtName: undefined,
        inter: undefined,
        name: undefined,
        nol1: undefined,
        dri: undefined,
        vehVsl: undefined,
        refNo: undefined
      },
      params: {
        polType: [],
        review: [
          {
            label: 'true',
            value: true
          },
          {
            label: 'false',
            value: false
          }
        ],
        status: [],
        busCls: [],
        covers: []
      },
      commonClaim: {
        claimNo: undefined,
        polNo: undefined,
        renCnt: undefined,
        endtCnt: undefined,
        insdName1: undefined,
        comDate: undefined,
        expDate: undefined,
        lossDate: undefined,
        clmStat: undefined,
        busCls: undefined
      },
      directRIList: [
        { label: 'Direct', value: 'D' },
        { label: 'Reinsurance', value: 'R' }
      ],
      polTypeList: [],
      showDetailFilters: false,
      showDeletePrompt: false,
      claimForDelete: {
        clmNo: undefined
      },
      initialLoad: true,
      showErrorDialog: false,
      pagination: {
        sortDesc: [true],
        page: 1
      },
      isAfterDefFilter: false,
      deleteMode: false,
      cfmExportClmList: false,
      labels: {
        exportList: 'Export List'
      },
      exportList: {
        promptFilterWarning: false,
        cfmExportClmList: false,
        promptFilterWarningMsg: 'Do you want to proceed without any filtering?'
      }
    }
  },
  watch: {
    tabs: function(value) {
      if (value === 0) {
        this.doColumn('Claim Details', this.columns)
      }
    },
    // 'claimListing.init': function(value) {
    //   if (value === 1) {
    //     // this.fetchData()
    //   }
    // },
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination': function(value) {
      if (this.isAfterDefFilter === true) {
        this.fetchData(false)
      }
    },
    displayErrorDialog: {
      handler: function(messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  methods: {
    assignClmEvent(clmEvent) {
      this.filters.clmEvent = clmEvent.eventType
    },
    visibleControl(data) {
      if (typeof data !== 'undefined') {
        this.visibleTab = { ...data }
        this.getDefaultFilter()
      } else {
        this.visibleTab = {}
      }
    },
    async doInit() {
      await Promise.all([this.$store.dispatch('claimsListingInit')])
      this.$store.commit(CLAIMS_LOAD_BACK_LISTING, '')
      this.cardMenu = []
      if (this.checkAccess([permissionKeys.perm_031005]) === true) {
        this.cardMenu.push({
          text: 'Claim',
          icon: 'mdi-file-check',
          name: '',
          params: { tab: 'listing' },
          access: '',
          default: true })
      }
      if (this.checkAccess([permissionKeys.perm_031010]) === true) {
        this.cardMenu.push({
          text: 'Payment',
          icon: 'fas fa-hand-holding-usd',
          name: '',
          params: { tab: 'payment' },
          access: '' })
      }
    },
    async fetchPolTypeList() {
      const apiUrl = this.$store.state.commons.menu.getPolTypeList
      if (apiUrl) {
        const result = await this.$http.get(apiUrl)
        const { data } = result
        let polTypeList = []
        if (data && data.data) {
          data.data.forEach(polType => {
            polTypeList.push({
              label: polType.polType + ' - ' + polType.polTypeDesc,
              value: polType.polType
            })
          })
        }
        this.polTypeList = polTypeList
      }
    },
    // Common Search Filter - Start
    reloadList(filterName) {
      this.defaultFilter.filterName = filterName
      this.saveFilter = false
      this.doButtons(this.visibleTab.tab)
    },
    applyDefaultFilter(filterData) {
      this.defaultFilter = filterData
      if (this.defaultFilter.filters !== undefined) {
        this.filters = this.defaultFilter.filters
      }
      this.showFilterList = false
      this.doButtons(this.visibleTab.tab)
    },
    async getDefaultFilter() {
      await Promise.all([this.$store.dispatch('searchFilterInit')])
      const apiUrl = this.$store.state.searchFilter.menu.defaultFilter
      if (apiUrl) {
        try {
          this.loading = true
          const expand = {
            filterCode: this.filterCode
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result.data
          this.initialLoad = false
          if (data) {
            this.defaultFilter.filterName = data.defaultFilter.filterName
            this.defaultFilter.filterDesc = data.defaultFilter.filterDesc
            this.defaultFilter.filterCode = data.defaultFilter.filterCode
            this.defaultFilter.filters = JSON.parse(data.defaultFilter.filterContent)
            if (this.defaultFilter.filters !== undefined) {
              this.filters = this.defaultFilter.filters
            }
            this.doButtons(this.visibleTab.tab)
          } else {
            this.doButtons(this.visibleTab.tab)
          }
          this.isAfterDefFilter = true
        } catch (err) {
          this.loading = false
        }
      }
    },
    // Common Search Filter - End
    async doRemove() {
      // placeholder
    },
    async doReview(data) {
      this.resetMessages()
      // AR: OS-660 Added to check if record is locked 2021-01-29
      this.checkRecordLock(data.item.clmNo, 'CLM').then(result => {
        // Record not locked proceed to review 2021-01-29
        if (!result) {
          this.performReview(data)
          // Record was locked show message 2021-01-29
        } else {
          this.loading = false
        }
      })
    },
    async performReview(data) {
      try {
        this.loading = true
        const dispatchObj = {
          clmNo: data.item.clmNo,
          query: false
        }
        await this.$store.dispatch('loadClaim', dispatchObj)
        this.$store.commit(CLAIMS_HASRIORRESADJ_LOADING)

        // Check status and redirect to the correct page
        /* // Remarked by lcd_20200918
        if (data.item.clmStat === 'O' || this.buttons === 'reopen') {
          this.$router.push({ name: 'claimHeader' })
        } else if (data.item.clmStat === 'C') {
          this.$router.push({ name: 'claimHeader' })
        } else {
          this.$toast.error('Invalid Status Code')
          this.loading = false
        }
        */
        // lcd_20200918
        if (this.buttons === undefined) {
          this.$router.push({ name: 'claimHeader' })
        } else if (this.buttons === 'reopen') {
          this.$router.push({ name: 'claimReopenHeader' })
        } else {
          this.$toast.error('Invalid Status Code')
          this.loading = false
        }
        // Dont have to set loading to false here. It should have been redirected
        // If somehow error occurs, by right they cant try to load again. Might have dirty data now
        // this.loading = false
      } catch (err) {
        if (err.response && err.response.data) {
          this.fullMessage(err.response.data)
        } else if (err.message) {
          this.errorMessage(err.message)
        }
        this.loading = false
      }
    },
    async doPay(data) {
      this.resetMessages()
      this.checkRecordLock(data.item.clmNo, 'CLM').then(result => {
        if (!result) {
          this.performPay(data)
        } else {
          this.loading = false
        }
      })
    },
    async performPay(data) {
      try {
        this.loading = true
        const dispatchObj = {
          clmNo: data.item.clmNo,
          query: false
        }

        await Promise.all([this.$store.dispatch('loadClaim', dispatchObj), this.$store.dispatch('claimsRegisterInit')])
        await Promise.all([this.$store.dispatch('claimEntryInit')])
        this.$router.push({ name: 'claimReserve' })
      } catch (err) {
        if (err.response && err.response.data) {
          this.fullMessage(err.response.data)
        } else if (err.message) {
          this.errorMessage(err.message)
        }
        this.loading = false
      }
    },
    // Find Claim Detail in Claim Master
    async fetchData() {
      this.items = []
      let apiUrl = this.$store.state.claims.claimListing.menu
      // tab key change url
      if (this.filterTab === 'Claim Details' && this.buttons === 'reopen') {
        // this.buttons = undefined
        apiUrl = this.$store.state.claims.claimListing.menu.getClaimReopen
      } else if (this.filterTab === 'Claim Details' && this.buttons === 'delete') {
        // this.buttons = undefined
        apiUrl = this.$store.state.claims.claimListing.menu.getClaimDelete
      } else if (this.filterTab === 'Claim Details' && this.buttons !== 'reopen' && this.buttons !== 'delete') {
        this.buttons = undefined
        apiUrl = this.$store.state.claims.claimListing.menu.getClaimDetail
      } else if (this.filterTab === 'Driver Details' && this.buttons === 'reopen') {
        // this.buttons = undefined
        apiUrl = this.$store.state.claims.claimListing.menu.getDriverReopen
      } else if (this.filterTab === 'Driver Details' && this.buttons === 'delete') {
        // this.buttons = undefined
        apiUrl = this.$store.state.claims.claimListing.menu.getDriverDelete
      } else if (this.filterTab === 'Driver Details' && this.buttons !== 'reopen' && this.buttons !== 'delete') {
        this.buttons = undefined
        apiUrl = this.$store.state.claims.claimListing.menu.getDriverDetail
      } else if (this.filterTab === 'Claimant Details' && this.buttons === 'reopen') {
        // this.buttons = undefined
        apiUrl = this.$store.state.claims.claimListing.menu.getClaimantReopen
      } else if (this.filterTab === 'Claimant Details' && this.buttons === 'delete') {
        // this.buttons = undefined
        apiUrl = this.$store.state.claims.claimListing.menu.getClaimantDelete
      } else if (this.filterTab === 'Claimant Details' && this.buttons !== 'reopen' && this.buttons !== 'delete') {
        this.buttons = undefined
        apiUrl = this.$store.state.claims.claimListing.menu.getClaimantDetail
      } else if (this.filterTab === 'Item Details' && this.buttons === 'reopen') {
        // this.buttons = undefined
        apiUrl = this.$store.state.claims.claimListing.menu.getItemReopen
      } else if (this.filterTab === 'Item Details' && this.buttons === 'delete') {
        // this.buttons = undefined
        apiUrl = this.$store.state.claims.claimListing.menu.getItemDelete
      } else if (this.filterTab === 'Item Details' && this.buttons !== 'reopen' && this.buttons !== 'delete') {
        this.buttons = undefined
        apiUrl = this.$store.state.claims.claimListing.menu.getItemDetail
      }
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          const expand = {
            page: page - 1,
            size: itemsPerPage
          }
          let massageFilters = clone(this.filters)
          if (massageFilters.lossDate) {
            const lossDate = removeTime(massageFilters.lossDate)
            massageFilters.lossDate = formatDisplayDateTime2(lossDate)
            massageFilters.lossDatePlus = formatDisplayDateTime2(addDays(lossDate, 1))
          }
          if (massageFilters.polTypeAppId && massageFilters.polTypeAppId === 'MI') {
            massageFilters.polTypeAppId = undefined
            massageFilters.polTypeAppId_NOTIN = 'CA,FI,HU,MO'
          }
          const result = await this.$http.get(
            filterQuery(expandURI(apiUrl, expand), massageFilters, this.pagination.sortBy, this.pagination.sortDesc)
          )
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              this.items = []
              // Format the data here
              data.map(claim => {
                const convertClaim = {
                  clmNo: claim.clmNo,
                  polNo: claim.polNo,
                  renCnt: claim.renCnt,
                  endtCnt: claim.endtCnt,
                  insdName1: claim.insdName1,
                  comDate: this.formatDate(claim.comDate),
                  expDate: this.formatDate(claim.expDate),
                  lossDate: this.formatDate(claim.lossDate),
                  clmStat: claim.clmStat,
                  busCls: claim.busCls,
                  driverName: claim.drvName,
                  driverNric: claim.drvIcNo,
                  clmtName: claim.clmtName,
                  clmtNo: claim.clmtNo,
                  clmtStat: claim.clmtStat,
                  clmtType: claim.clmtType,
                  clmItem: claim.clmItem,
                  clmEvent: claim.clmEvent,
                  inter: claim.inter,
                  name: claim.name,
                  nol1: claim.nol1,
                  dri: claim.dri,
                  polType: claim.polType,
                  vehRegNo: claim.vehRegNo
                }
                this.items.push(convertClaim)
              })
            } else {
              this.items = []
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doColumn(detailTab, columns) {
      this.filterTab = undefined
      this.columns = []
      if (detailTab === 'Claim Details') {
        this.selectedColumns = ['clmNo', 'polNo', 'renCnt', 'endtCnt', 'lossDate', 'insdName1', 'busCls', 'clmStat']
        this.tab = 'Claim Details'
        this.filterTab = 'Claim Details'
        this.columns = Object.assign(this.columns, this.defaultColumns)
        this.columns.push(
          { text: 'Policy No.', value: 'polNo' },
          { text: 'Claim Event No.', value: 'clmEvent' },
          { text: 'Ren', value: 'renCnt' },
          { text: 'Endt', value: 'endtCnt' },
          { text: 'Insured Name', value: 'insdName1' },
          { text: 'Com.Date', value: 'comDate' },
          { text: 'Exp.Date', value: 'expDate' },
          { text: 'Loss Date', value: 'lossDate' },
          { text: 'Class', value: 'busCls' },
          { text: 'DRI', value: 'dri' },
          { text: 'Vehicle Reg No.', value: 'vehRegNo' },
          { text: 'Vehicle Reg No. / Vessel Name', value: 'vehVsl' },
          { text: 'Policy Type', value: 'polType' }
        )
        if (this.initialLoad === false) {
          this.fetchData(false)
        }
      } else if (detailTab === 'Driver Details') {
        this.selectedColumns = ['clmNo', 'lossDate', 'insdName1', 'busCls', 'driverName', 'driverNric', 'clmStat']
        this.filterTab = 'Driver Details'
        this.columns = Object.assign(this.columns, this.defaultColumns)
        this.columns.push(
          { text: 'Insured Name', value: 'insdName1' },
          { text: 'Com.Date', value: 'comDate' },
          { text: 'Exp.Date', value: 'expDate' },
          { text: 'Loss Date', value: 'lossDate' },
          { text: 'Class', value: 'busCls' },
          { text: 'DRI', value: 'dri' },
          { text: 'Vehicle Reg No.', value: 'vehRegNo' },
          { text: 'Vehicle / Vessel', value: 'vehVsl' },
          { text: 'Driver Name', align: 'left', value: 'driverName' },
          { text: 'Driver NRIC', align: 'left', value: 'driverNric' }
        )
        if (this.initialLoad === false) {
          this.fetchData(false)
        }
      } else if (detailTab === 'Claimant Details') {
        this.selectedColumns = ['clmNo', 'clmtNo', 'clmtName', 'clmtStat', 'clmtType', 'vehRegNo', 'clmStat']
        this.filterTab = 'Claimant Details'
        this.columns = Object.assign(this.columns, this.defaultColumns)
        this.columns.push(
          { text: 'Claimant No.', align: 'left', value: 'clmtNo' },
          { text: 'Claimant Name', align: 'left', value: 'clmtName' },
          { text: 'Claimant Status', align: 'left', value: 'clmtStat' },
          { text: 'Claimant Type', align: 'left', value: 'clmtType' },
          { text: 'Claimant Vehicle', align: 'left', value: 'vehRegNo' }
        )
        if (this.initialLoad === false) {
          this.fetchData(false)
        }
      } else if (detailTab === 'Item Details') {
        this.selectedColumns = ['clmNo', 'clmtNo', 'clmtName', 'clmItem', 'nol1', 'clmStat']
        this.filterTab = 'Item Details'
        this.columns = Object.assign(this.columns, this.defaultColumns)
        this.columns.push(
          { text: 'Policy No.', value: 'polNo' },
          { text: 'Claim Event No.', value: 'clmEvent' },
          { text: 'Ren', value: 'renCnt' },
          { text: 'Endt', value: 'endtCnt' },
          { text: 'Claimant No.', align: 'left', value: 'clmtNo' },
          { text: 'Claimant Name', align: 'left', value: 'clmtName' },
          { text: 'Claimant Vehicle', align: 'left', value: 'vehRegNo' },
          { text: 'Claim Item No.', align: 'left', value: 'clmItem' },
          { text: 'NOL', align: 'left', value: 'nol1' }
        )
        if (this.initialLoad === false) {
          this.fetchData(false)
        }
      }
    },
    disabledTabs(detailTab) {
      if (this.filters.review) {
        return false
        // if (detailTab === 'Claimant Details') {
        //   return false
        // } else if (detailTab === 'Driver Details') {
        //   return false
        // } else {
        //   return false
        // }
      }
    },
    async doCreate() {
      this.$router.push({ name: 'claimRegister' })
    },
    async doQuery(data, remove) {
      this.resetMessages()
      try {
        this.loading = true
        const dispatchObj = {
          clmNo: data.item.clmNo,
          remove: remove,
          query: false
        }
        await this.$store.dispatch('loadClaim', dispatchObj)
        await this.$store.dispatch('claimEntryInit')
        await this.$store.dispatch('claimsRegisterInit')
        // Check status and redirect to the correct page
        this.$router.push({ name: 'qClaimHeader' })

        // Dont have to set loading to false here. It should have been redirected
        // If somehow error occurs, by right they cant try to load again. Might have dirty data now
        // this.loading = false
      } catch (err) {
        if (err.response && err.response.data) {
          this.fullMessage(err.response.data)
        } else if (err.message) {
          this.errorMessage(err.message)
        }
        this.loading = false
      }
    },
    doButtons(data) {
      this.filters.review = data
      this.filters.clmStat = undefined
      this.deleteMode = false
      if (data === 'reopen') {
        this.buttons = 'reopen'
        this.filters.clmStat = 'C'
        this.fetchData(true)
        this.listMode = 'Reopen Claim'
      } else if (data === 'delete') {
        this.buttons = 'delete'
        this.fetchData(true)
        this.listMode = 'Delete Claim'
        this.deleteMode = true
      } else if (data === 'listing') {
        this.buttons = 'listing'
        this.fetchData(true)
        this.listMode = 'Claim'
      } else if (data === 'payment') {
        this.buttons = 'payment'
        this.fetchData(true)
        this.listMode = 'Payment'
      } else {
        this.fetchData(false)
      }
    },
    canQuery(data) {
      return (
        this.filters.review === 'listing' || this.filters.review === 'payment' || this.filters.review === 'reopen' || this.filters.review === 'delete'
      )
    },
    canCreate(data) {
      return this.filters.review === 'payment' && data.item.clmStat !== 'C'
    },
    canReview(data) {
      /* if (this.filters.review === 'listing' || this.filters.review === 'reopen') { */ // Remarked by lcd_20200925
      return this.filters.review === 'listing' && (data.item.clmStat !== 'C' && data.item.clmStat !== 'C (P)')
    },
    canReviewReopen(data) {
      return this.filters.review === 'reopen' && (data.item.clmStat === 'C' || data.item.clmStat === 'C (P)')
    },
    canDelete(data) {
      return this.filters.review === 'delete' && data.item.clmStat !== 'C'
    },
    doClearFilters() {
      this.filters.review = 'listing'
      this.filters.polType = null
      this.filters.clmNo = null
      this.filters.polNo = null
      this.filters.insdName1 = null
      this.filters.busCls = null
      this.filters.clmEvent = null
      this.filters.lossDate = null
      this.filters.vehRegNo = null
      this.filters.engineNo = null
      this.filters.chassisNo = null
      this.filters.cedantClmNo = null
      this.filters.contrtNo = null
      this.filters.driverName = null
      this.filters.driverNric = null
      this.filters.clmtName = null
      this.filters.inter = null
      this.filters.name = null
      this.filters.nol1 = null
      this.filters.dri = null
      this.filters.vehVsl = null
      if (this.buttons === 'reopen') {
        this.filters.clmStat = 'C'
      } else {
        this.filters.clmStat = null
      }
      this.tab = 0
      this.defaultFilter = {}
      this.fetchData(false)
    },
    doFilters() {
      this.resetMessages()
      this.tab = 0
      this.$validator.validateAll().then(result => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.fetchData(false)
        }
      })
    },
    checkFiltersNullValue() {
      const ignore = ['polTypeAppId', 'review']
      return Object.keys(this.filters)
        .filter(key => !ignore.includes(key))
        .every(key => this.filters[key] === null ||
          this.filters[key] === '' ||
          this.filters[key] === undefined
        )
    },
    doExportFilters() {
      const checknull = this.checkFiltersNullValue()
      if (checknull) {
        this.exportList.promptFilterWarning = true
      } else {
        this.exportList.promptFilterWarning = false
        this.exportList.cfmExportClmList = true
      }
    },
    async doExportList(columns, columnsTitle) {
      const apiUrl = this.$store.state.claims.claimListing.menu.exportClmFilteredList
      if (apiUrl) {
        try {
          let massageForm = clone(this.filters)
          massageForm.columns = columns
          massageForm.columnsTitle = columnsTitle
          massageForm.mode = this.filters.review
          massageForm.detailTabs = this.filterTab
          massageForm.claimType = this.buttons
          await this.$http.post(apiUrl, massageForm)
          this.processing = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  mounted() {
    // AR: OS-660 Added to check record lock 2021-01-21
    this.initCommonUtilMenu()
    this.fetchPolTypeList()
    this.doInit()
  },
  created() {},
  computed: {
    ...mapGetters(['checkAccess']),
    claimListing() {
      return this.$store.state.claims.claimListing
    },
    busClsList() {
      return this.claimListing.busClsList || []
    },
    clmStatList() {
      return this.claimListing.clmStatList || []
    },
    interList() {
      return this.claimListing.interList || []
    },
    nol1List() {
      return this.claimListing.nol1List || []
    },
    polTypeAppIdList() {
      let result = []
      Object.keys(mainClass).forEach(function(key) {
        const status = mainClass[key]
        if (key === 'NULL') {
          result.push({
            label: status,
            value: null
          })
        } else {
          result.push({
            // label: key + ' - ' + status,
            label: status,
            value: key
          })
        }
      })
      return result
    },
    displayErrorDialog() {
      return this.messages
    }
  },
  mixins: [listMixin, recordLockMixin],
  components: {
    SearchFilter,
    UpdateSearchFilter,
    ClmEventHelpList
  }
}
</script>

<style lang="scss"></style>
